


const baseURL = process.env.REACT_APP_BASE_URL;

export const API_MAP = {
  APPLY_LEAVE: {
    endpoint: `${baseURL}/Leave/Apply`,
    method: "POST",

    requiredFields: [
      "LeaveTypeId",
      "Reason",
      "StartDate",
      "EndDate",
      "IsHalfDay",
      "HalfPreference"
    ],

    questions: {
      LeaveTypeId:
        "Which type of leave do you want to apply for?\n• Planned Leave\n• Un-Planned Leave\n• Maternity Leave\n• Paternity Leave\n• Hospitalization Leave\n• Leave Without Pay\n• Special Day Leave",
      Reason: "What is the reason for your leave?",
      StartDate: "Please enter the start date (YYYY-MM-DD).",
      EndDate: "Please enter the end date (YYYY-MM-DD).",
      IsHalfDay: "Is this a half-day leave? (yes or no)",
      HalfPreference: "Is it first half or second half?"
    },

    // Maps leave type name → LeaveTypeId numeric value
    leaveTypeMap: {
      "planned leave": 101,
      "un-planned leave": 102,
      "unplanned leave": 102,
      "maternity leave": 103,
      "paternity leave": 104,
      "hospitalization leave": 105,
      "leave without pay": 106,
      "lwp": 106,
      "special day leave": 107,
      "sdl": 107
    }
  },

  APPLY_WFH: {
    endpoint: `${baseURL}/WFH/Apply`,
    method: "POST",

    requiredFields: [
      "Reason",
      "StartDate",
      "EndDate",
      "IsHalfDay",
      "HalfPreference"
    ],

    questions: {
      Reason: "What is the reason for your WFH request?",
      StartDate: "Please enter the WFH start date (YYYY-MM-DD).",
      EndDate: "Please enter the WFH end date (YYYY-MM-DD).",
      IsHalfDay: "Is this a half-day WFH? (yes or no)",
      HalfPreference: "Is it first half or second half?"
    },

    // Fixed status ID for WFH application (pending/applied)
    WFHStatusId: 103
  },

  LEAVE_BALANCE: {
    endpoint: `${baseURL}/Leave/Balance`,
    method: "GET"
  },

  NEXT_HOLIDAY: {
    endpoint: `${baseURL}/Holiday/Next`,
    method: "GET"
  }
};

